import { Column, Index, JoinColumn, ManyToOne } from 'typeorm';
import { Entity } from '../../decorators';
import { BaseEntity } from './base.entity';
import { ContactEntity } from './contact.entity';
import { MSmClientOpportunityEntity } from './m-sm-client-opportunity.entity';

/** PD-17101 — the part a person plays in a deal (O5). */
export const OPPORTUNITY_CONTACT_ROLES = [
	'decision_maker',
	'influencer',
	'buyer',
	'estimator',
	'engineer',
	'other',
] as const;

export type OpportunityContactRole = (typeof OPPORTUNITY_CONTACT_ROLES)[number];

export const OPPORTUNITY_CONTACT_ROLE_LABELS: Readonly<Record<OpportunityContactRole, string>> = {
	decision_maker: 'Decision maker',
	influencer: 'Influencer',
	buyer: 'Buyer',
	estimator: 'Estimator',
	engineer: 'Engineer or specifier',
	other: 'Other',
};

/**
 * PD-17101 — a person on an opportunity with their role in the deal. The
 * person is a `contact` (any of the customer's people, or anyone from the
 * people list); the role is this deal's, not their contact role at the
 * customer.
 *
 * SM1 exposure: none (a new table).
 */
@Index('opportunity_contact__opportunity_contact', ['fkOpportunityId', 'fkContactId'], {
	unique: true,
})
@Index('opportunity_contact__fk_contact__id', ['fkContactId'], {})
@Entity('opportunity_contact')
export class OpportunityContactEntity extends BaseEntity {
	@Column('int', { name: 'fk_m_sm_client_opportunity__id', unsigned: true })
	public fkOpportunityId!: number;

	@Column('int', { name: 'fk_contact__id', unsigned: true })
	public fkContactId!: number;

	@Column('varchar', { name: 'role', length: 32, default: () => "'other'" })
	public role!: OpportunityContactRole;

	@ManyToOne(() => MSmClientOpportunityEntity, { onDelete: 'CASCADE', onUpdate: 'RESTRICT' })
	@JoinColumn([{ name: 'fk_m_sm_client_opportunity__id', referencedColumnName: 'id' }])
	public opportunity!: MSmClientOpportunityEntity;

	@ManyToOne(() => ContactEntity, { onDelete: 'CASCADE', onUpdate: 'RESTRICT' })
	@JoinColumn([{ name: 'fk_contact__id', referencedColumnName: 'id' }])
	public contact!: ContactEntity;
}
